import React from 'react';

import FilterSelector from './FilterSelector';

import { SearchInput } from '@/components/ui/input/SearchInput';

interface CountDisplay {
	label: string;
	value: number | string;
	dataTest?: string;
}

interface SearchConfig {
	query: string;
	setQuery: React.Dispatch<React.SetStateAction<string>>;
	placeholder: string;
	refetch: () => void;
}

interface FilterConfig {
	setFilterSelected: (filterValue: string) => void;
	filterList: { label: string }[];
}

interface TableHeaderProps {
	title: string;
	counts: CountDisplay[];
	searchConfigs: SearchConfig[];
	filterConfig?: FilterConfig;
	className?: string;
}

const TableHeader: React.FC<TableHeaderProps> = ({
	title,
	counts,
	searchConfigs,
	filterConfig,
	className = '',
}) => {
	return (
		<div
			className={`flex flex-col items-center border-t border-gray-300 w-full bg-grey-0 border rounded-md px-[2rem] ${className}`}
		>
			<h3 className="text-md leading-5 font-medium py-[2rem] w-full">
				{title}
			</h3>
			<div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full mb-4 gap-4 lg:gap-0">
				{/* Left section - Filter and Counts */}
				<div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0">
					{filterConfig && (
						<FilterSelector
							setFilterSelected={filterConfig.setFilterSelected}
							filterList={filterConfig.filterList}
						/>
					)}
					<div className="flex flex-wrap items-center gap-2 sm:gap-0">
						{counts.map((count, index) => (
							<div
								key={index}
								data-test={count.dataTest}
								className="inter-small-semibold p-3 text-grey-50 whitespace-nowrap"
							>
								{`${count.label}: ${count.value}`}
							</div>
						))}
					</div>
				</div>

				{/* Right section - Search Inputs */}
				<div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
					{searchConfigs.map((searchConfig, index) => (
						<SearchInput
							key={index}
							refetch={searchConfig.refetch}
							query={searchConfig.query}
							setQuery={searchConfig.setQuery}
							placeholder={searchConfig.placeholder}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default TableHeader;
